import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Drawer, Form, Row, Col ,Button, Space} from "antd"
import { ApiCalls } from "../../../shared/ApiCalls"
import { methodUrlType } from "../../../shared/lookups"
import { MyInput, MySelect, MySwitch} from "../../Forms"
import { actionsApi } from "../../../shared"

const UpdatePortalDrawer = ({visible, onClose}) => {
    
    const dispatch= useDispatch()
    const [form] = Form.useForm()
    const [ loading, setLoading ] = useState(false)  
    const [portalType, setPortalType]= useState(1)
  
    useEffect(() => {
        if (visible){
            setPortalType(parseInt(visible?.methodType))
            form.setFieldsValue({...visible, urlType: parseInt(visible?.methodType)})
        }
        else 
            form.resetFields()
    }, [visible])
    const onFinish = async () => {
        try {
            let portal= await form.validateFields()
            portal={
                ...portal, 
                isLock: portal?.isLock ? 1 : 0,
                methodType: portal?.urlType,
                macAddress: visible?.macAddress
            }
            if(portal?.urlType !== 3){
                delete portal?.userName 
                delete portal?.password
            }
            setLoading(true)
            const result = await ApiCalls?.AddEditBoxApi?.updatePortal({...portal,id: visible?.id});
            setLoading(false)
            if(result){
                onClose()
                 dispatch(actionsApi?.getPortals(visible?.andriodBoxesID))
            }
        } catch (error) {
            console.error("Form validation error:", error);
        }
    }

  return (
    <div>
        <Drawer
            title= "Update Portal"
            onClose={onClose}
            open={visible}
            width={800}
            footer={
                <Space className="w-100">
                    <Button 
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button  
                        block
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        onClick={()=> form.submit()}
                    >
                        Update Portal
                    </Button>
                </Space>
            }
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={true}
                onFinish={onFinish}
              
            >
                <Row gutter={[16, 0]} align="middle">
                    <Col span={10}>
                        <MySelect 
                            label= {'URL Type'}
                            name= "urlType"
                            required
                            message='Please choose url type'
                            placeholder='choose url type'
                            options={methodUrlType}
                        />
                    </Col>
                    <Col span={10}>
                        <MyInput
                            label= "Name"
                            name= "name"
                            placeholder='e.g my m3u'
                            required
                            message='Please enter name'
                        />
                    </Col>
                    <Col span={10}>
                        <MyInput
                            label={'Url'}
                            name= "url"
                            placeholder='e.g www.example.com'
                            required
                            message='Please enter url'
                        />
                    </Col>
                    {
                        portalType === 3?
                        <>
                            <Col span={10}>
                                <MyInput
                                    label='Username'
                                    name= "userName"
                                    placeholder='e.g myapi.er'
                                    required
                                    message='Please enter username'
                                />
                            </Col>
                            <Col span={10}>
                                <MyInput
                                    label='Password'
                                    name= "password"
                                    placeholder='e.g myapi.er'
                                    required
                                    message='Please enter password'
                                />
                            </Col>
                        </>
                        :
                        <></>
                    }
                    <Col span={3}>
                        <MySwitch
                            label= {null}
                            name= "isLock"
                            defaultChecked={false}
                        />
                    </Col>
                </Row>
            </Form>
        </Drawer>
    </div>
  )
}

export {UpdatePortalDrawer}